// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"418":"31b4eb5e","668":"a1c47322"}[chunkId] + ".js";
};